export default __webpack_public_path__ + "static/media/Card Snippet.d95fec7a.svg";